import { Module } from 'wrapper6'
import tippy from 'tippy.js'

export default class Tooltip extends Module {
  ready (app) {
    tippy('[data-tippy-content]', {
      theme: 'light',
      placement: 'bottom'
    })
  }
}
